import { render, staticRenderFns } from "./JobPanel.vue?vue&type=template&id=15b57edd&"
import script from "./JobPanel.vue?vue&type=script&lang=js&"
export * from "./JobPanel.vue?vue&type=script&lang=js&"
import style0 from "./JobPanel.vue?vue&type=style&index=0&id=15b57edd&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports